export const STAY = 'STAY'
export const FLY = 'FLY'
export const DRIVE = 'DRIVE'
export const STAY_DRIVE = 'STAY:DRIVE'
export const STAY_FLY = 'STAY:FLY'
export const STAY_FLY_DRIVE = 'STAY:FLY:DRIVE'

export const ADD_PRODUCT_OPTIONS = [
  {
    name: 'car',
    type: DRIVE,
    label: 'Add a car',
    id: 'add-a-car-checkbox'
  },
  {
    name: 'flight',
    type: FLY,
    label: 'Add a flight',
    id: 'add-a-flight-checkbox'
  }
] as const

export const PromoDeal = {
  EXPRESS_DEAL: 'EXPRESS_DEAL',
  COLLECTIONS: 'COLLECTIONS',
  VIP: 'VIP',
  NHA: 'NHA'
} as const

export const CALENDAR_POPOVER_SELECTOR =
  '[aria-label="Calendar navigation tooltip"]'

export const PRIMARY_HEADING_FALLBACK = 'Searching for a place to stay?'

export const BANNER_TEXT_PRIMARY = 'Save up to 60% by searching Express Deals.'
export const BANNER_TEXT_SECONDARY =
  'Incredible deals from independent hotels and well-known brands.'

export const GEO = 'GEO'
